<script setup lang="ts">
import { SearchOverlayProps } from "./SearchOverlay.props"

defineProps<SearchOverlayProps>()
const overlayRef = ref(null)
const overlayHeight = ref(0)

useResizeObserver(overlayRef, (entries) => {
  const entry = entries[0]
  const { height } = entry.contentRect
  overlayHeight.value = height
})
</script>

<template>
  <div class="relative overflow-y-auto transition-all" ref="overlayRef">
    <slot />
  </div>
</template>
